import React, { useEffect } from "react";
import "./CoursEducation.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import Tarifs from "../../sections/Tarifs/Tarifs";
import { coursEducData } from "../../data/coursEducData";
import TrustIndexWidget from "../../sections/TrustIndexWidget/TrustIndexWidget";
import Contact from "../../sections/Contact/Contact";
import { Helmet } from "react-helmet";

const CoursEducation = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    const handleAnimationEnd = (e) => {
      if (e.target.hasAttribute("data-aos")) {
        e.target.removeAttribute("data-aos");
      }
    };

    const elements = document.querySelectorAll("[data-aos]");

    elements.forEach((element) => {
      element.addEventListener("transitionend", handleAnimationEnd);
    });

    return () => {
      elements.forEach((element) => {
        element.removeEventListener("transitionend", handleAnimationEnd);
      });
    };
  }, []);

  return (
    <div id="cours-educ">
      <Helmet>
        <title>Cours d'éducation | Pokélu</title>
        <meta
          name="description"
          key="description"
          content="L’éducation joue un rôle fondamental dans l’épanouissement de votre animal et dans votre relation avec lui. Elle permet non seulement d’établir un lien de confiance solide, mais aussi de favoriser une cohabitation sereine et équilibrée."
        />
      </Helmet>
      <section className="cours-container section-container">
        <h1 className="title">Cours d'éducation</h1>
        <div className="flex-container">
          <div className="text-content" data-aos="fade-right">
            <p>
              L’éducation joue un rôle{" "}
              <strong>fondamental dans l’épanouissement de votre animal</strong>{" "}
              et dans votre relation avec lui. Elle permet non seulement d’
              <strong>établir un lien de confiance solide</strong>, mais aussi
              de favoriser une{" "}
              <strong>cohabitation sereine et équilibrée</strong>.
            </p>
            <p>
              Grâce à une <strong>approche bienveillante et positive</strong>,
              l’éducation aide à canaliser l’énergie de votre compagnon et à
              orienter son comportement de manière{" "}
              <strong>adaptée à votre mode de vie</strong>. Elle constitue une
              véritable <strong>opportunité</strong> de renforcer votre
              complicité tout en instaurant des bases solides pour une relation
              harmonieuse.
            </p>
            <p>
              En tant qu’éducatrice, je vous accompagne avec{" "}
              <strong>professionnalisme et engagement</strong> afin de vous
              transmettre toutes les clés nécessaires pour mieux comprendre
              votre animal et répondre à ses besoins de manière respectueuse et
              efficace. Ensemble, nous construirons{" "}
              <strong>
                une relation durable, fondée sur la confiance, la communication
                et le respect mutuel
              </strong>
              .
            </p>
          </div>
          <div className="image-container" data-aos="fade-left">
            <img
              src="/img/cours-educ/educ.webp"
              alt="Cours Femme qui apprend à chien"
            />
          </div>
        </div>
      </section>
      <Tarifs
        listTarifs={coursEducData}
        accroche="Comprendre, communiquer, éduquer : <strong>les clés d’un chien épanoui</strong> et bien dans ses pattes."
        isEduc={true}
      />
      {/* <TrustIndexWidget />  */}
      <Contact />
    </div>
  );
};

export default CoursEducation;
